@if (!showVerificationForm) {
  <div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
    <h6 mat-dialog-title>
      {{ sysText.changePhoneNumberDialog_title | titlecase }}
    </h6>
    @if (isMobile$ | async) {
      <span class="spacer"></span>
      <button
        type="button"
        class="button-reset"
        [mat-dialog-close]
        [aria-label]="sysText.cancel"
        [disabled]="isSubmitting$ | async">
        <mat-icon class="button-icon">close</mat-icon>
      </button>
    }
  </div>
  <mat-dialog-content [formGroup]="form">
    <p class="subtitle1 bottom-margin">
      {{ sysText.changePhoneNumberDialog_subtitle }}
    </p>
    <mat-form-field color="accent">
      <mat-label>{{ sysText.newPhoneNumber | titlecase }}</mat-label>
      <input
        matInput
        type="string"
        formControlName="phoneNumber"
        autocomplete="tel"/>
      <mat-error>{{ phoneNumber.errors?.required ? (sysText.required | capitalizefirst) : phoneNumber.errors?.msError }}</mat-error>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    @let isSubmitting = isSubmitting$ | async;
    @if (!(isMobile$ | async)) {
      <button
        mat-stroked-button
        class="button"
        type="button"
        [mat-dialog-close]
        color="accent"
        [disabled]="isSubmitting">
        {{ sysText.cancel }}
      </button>
    }
    <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
    <button
      mat-stroked-button
      class="button"
      type="submit"
      color="accent"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting"
      [attr.aria-label]="isSubmitting ? sysText.submitting_ariaLabel : null"
      (click)="!isSubmitting && changePhoneNumber()">
      {{ sysText.changePhoneNumber }}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  </mat-dialog-actions>
}
@if (showVerificationForm) {
  <div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
    <h6 mat-dialog-title>
      {{ sysText.changePhoneNumberDialog_verify_title | titlecase }}
    </h6>
    @if (isMobile$ | async) {
      <span class="spacer"></span>
      <button
        type="button"
        class="button-reset"
        [mat-dialog-close]
        [aria-label]="sysText.cancel"
        [disabled]="isSubmitting$ | async">
        <mat-icon class="button-icon">close</mat-icon>
      </button>
    }
  </div>
  <mat-dialog-content [formGroup]="verifyForm">
    <p class="subtitle1">
      {{ sysText.changePhoneNumberDialog_verify_subtitle }}
    </p>
    <mat-form-field color="accent">
      <mat-label>{{ sysText.code | titlecase }}</mat-label>
      <input
        matInput
        #otpInput
        type="number"
        formControlName="otp"
        autocomplete="off"/>
      <mat-error>{{ otp.errors?.required ? (sysText.required | capitalizefirst) : otp.errors?.msError }}</mat-error>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    @let isSubmitting = isSubmitting$ | async;
    <!-- resend and verify share isSubmitting$, so submittingAction says which one was pressed: that one shows the spinner
    (showProgress) and the "loading" label. both stay focusable while busy (disabledInteractive), and the guards block clicks -->
    <button
      mat-stroked-button
      class="button"
      type="button"
      color="accent"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting && submittingAction === 'resend'"
      [attr.aria-label]="isSubmitting && submittingAction === 'resend' ? sysText.submitting_ariaLabel : null"
      (click)="!isSubmitting && onResend()">
      {{ sysText.changePhoneNumberDialog_resendCode}}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
    @if (!(isMobile$ | async)) {
      <button
        mat-stroked-button
        class="button"
        type="button"
        [mat-dialog-close]
        color="accent"
        [disabled]="isSubmitting">
        {{ sysText.cancel }}
      </button>
    }
    <button
      mat-stroked-button
      class="button"
      type="submit"
      color="accent"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting && submittingAction === 'verify'"
      [attr.aria-label]="isSubmitting && submittingAction === 'verify' ? sysText.submitting_ariaLabel : null"
      (click)="!isSubmitting && confirmPhoneNumber()">
      {{ sysText.verify_changePhoneNumber }}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  </mat-dialog-actions>
}
